import Config from './config';

const DEFAULT_NAME = 'ga';

export default class Trackinghatch {

  constructor(document) {
    this.doc = document;
    this.trackinghatchApi = Config.TRACKINGHATCH_ENDPOINT;
  }

  /**
   * Event Send
   * @param {string} eventName
   * @param {any} content
   * @param {any} items
   * @param {any} param
   */
  sendEvent(eventName, content, items, param) {
    const ga = this._getGa();
    if (!ga) {
      return;
    }

    new Promise((resolve, reject) => {
      const dimension = param.params.device === 'SP' ? 'dimension22' : 'dimension5';
      ga((tracker) => {
        const getClientId = tracker.get('clientId');
        ga('set', dimension, getClientId);
        return resolve(getClientId);
      });
    }).then((clientId) => {
      const params = {
        'referer'     : param.referer || null,     // "フィードAPI呼び出しで指定されたReferer（任意）",
        'event.name'  : eventName,                 // "ipfeed.impression or ipfeed.click",
        'identifier'  : param.istyle_id || null,   // "暗号化されたistyle_id（任意）",
        'visitor_id'  : param.visitor_id || null,  // "アプリ側のvisitor_id(任意）",
        'ga.client_id': clientId,                  // "取得したGAのClientID",
        'href'        : items.url,                 // "遷移先URL",
        'content'     : content,                   // "フィードID_表示位置",
        'creation_id' : items.creation.id || null, // "案件とログを紐づけるための案件ID",
      };

      if (process.env.NODE_ENV !== 'production') {
        console.log('Sending trackinghatch event.', params);
      }
      // 送信
      this.sendTrackinghatch(params);
    }).catch((error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('Sending trackinghatch failed.');
      }
    });
  }

  sendTrackinghatch(params) {
    fetch(this.trackinghatchApi, {
      method  : 'post',
      mode    : 'cors',
      body    : JSON.stringify(params),
      headers : {
        'Accept'      : 'application/json',
        'Content-Type': 'application/json'
      }
    });
  }

  _getGa() {
    const win       = this.doc.defaultView || this.doc.parentWindow;
    const name      = win.GoogleAnalyticsObject || DEFAULT_NAME;
    const analytics = win[name] || win[DEFAULT_NAME];

    if (!analytics && process.env.NODE_ENV !== 'production') {
      console.log('ga is not detected.');
    }

    return analytics;
  }
}
